var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { StyledActionBarButton } from "./ActionBarButton.style";
import useUniqueId from "../../hooks/useUniqueId";
import { StyledIcon } from "../menu/ActionMenuItem.style";
const prefixId = "nx-actionbar-button-";
const ActionBarButton = forwardRef(function ActionBarButton(_a, ref) {
    var { id, children: label, iconName } = _a, rest = __rest(_a, ["id", "children", "iconName"]);
    id = useUniqueId(prefixId, id);
    return (React.createElement(StyledActionBarButton, Object.assign({ id: id, ref: ref, "aria-label": `${label}`, variant: "secondary" }, rest),
        iconName && React.createElement(StyledIcon, { name: iconName }),
        label));
});
export default ActionBarButton;
//# sourceMappingURL=ActionBarButton.js.map